// extracted by mini-css-extract-plugin
module.exports = {"loading":"UploadHistory_loading__2u2xg","rotating":"UploadHistory_rotating__tf7zY","clock":"UploadHistory_clock__2HWnt","success":"UploadHistory_success__xyRiJ"};